import en from './en.json';
import tr from './tr.json';

const translations = { en, tr };

export default translations;